import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=6af17534"
import script from "./DataChart.vue?vue&type=script&lang=js"
export * from "./DataChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports